'use strict'; // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.

var blockies = require('blockies');

// jsdom doesn't have all the browser features, blockies fail
var TEST_ENV = process.env.NODE_ENV === 'test';

function createIdentityImg(address) {var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
  return TEST_ENV ?
  'test-createIdentityImg' :
  blockies({
    seed: (address || '').toLowerCase(),
    size: 8,
    scale: scale }).
  toDataURL();
}

module.exports = {
  createIdentityImg: createIdentityImg };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/api/lib/util/identity.js
// module id = 492
// module chunks = 0